module.exports = __webpack_public_path__ + "img/login-background.bda6eeb3.png";